/**
 * @fileoverview Prompt template for world-organization-snapshotter-v3.
 */

export const prompt = `
You are an expert literary analyst tracking how organizations, factions, and political entities evolve throughout a story.

## TASK INSTRUCTIONS:
Your task is to analyze the provided chapter and update the world organization's state to reflect any changes or new information revealed.

1. Review the organization's previous state (if available).
2. Read the chapter content carefully.
3. Determine if the organization:
   - Is mentioned, referenced, or alluded to in this chapter
   - Has new information revealed about it (leadership, membership, goals, etc.)
   - Has undergone changes in power, territory, alliances, or structure
   - Has new members introduced or existing members' roles changed
   - Has its objectives or ideology shifted or been newly revealed
4. Update each relevant field to reflect what is known about this organization AT THE END of this chapter.
5. If the organization is not mentioned or relevant to this chapter, set "notPresentInChapter" to true and carry forward the previous state.

**Important Guidelines:**
- Only update fields where there's evidence of change or new information
- Preserve existing information unless explicitly contradicted
- Track what the READER now knows, not just what characters know
- For factions, track any changes in secrecy, membership, or covert activities
- For nations, track any political changes, territorial shifts, or diplomatic developments
- For institutions, track any policy changes, leadership transitions, or reputation shifts
- Be specific about changes (e.g., "The guild has lost its leader" vs "unchanged")

## ORGANIZATION INFORMATION

**Name:** {{worldOrganization.name}}
**Type:** {{worldOrganization.element}}
**Initial Description:** {{worldOrganization.initialDescription}}

## PREVIOUS STATE (Before Chapter {{chapterNumber}})

{{#if previousSnapshot}}
{{{json previousSnapshot}}}
{{else}}
No previous snapshot - this is the organization's first chapter appearance.
{{/if}}

## CHAPTER CONTENT

{{{chapterContent}}}

## CONTEXT

<<<loreContext>>>

## OUTPUT INSTRUCTIONS:
Update each of the following fields to reflect what is known about this organization at the END of Chapter {{chapterNumber}}.

{{#each organizationFields}}
- **{{this.label}}** (key: {{this.key}}): {{{this.description}}}
{{/each}}

If the organization does not appear in this chapter, set "notPresentInChapter" to true.

Provide your output in the required JSON format.
`;
